<template>
  <v-container>
    <v-layout justify-center>
      <v-slide-x-transition mode="out-in">
        <v-flex class="blue-grey--text font-weight-light headline" :key="message" shrink>{{message}}</v-flex>
      </v-slide-x-transition>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("featureRules", ["classification", "feature", "items"]),
    message() {
      if (!this.classification) {
        return "Elige una clasificación";
      }

      if (!this.feature) {
        return "Elige un atributo o crea uno nuevo";
      }

      return "";
    }
  }
};
</script>